import React from 'react';
import SidebarDashboard from '../components/SidebarDashboard';

const Transaction = () => {
  return (
    <div className='main-dashboard-page-content'>
    <div className='pagecontentspace container'>
    <nav class="navbar bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand d-p">Wallet</a>
    <form class="d-flex" role="search">
    <button class="btn " type="submit">AWB</button>
      <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
    </form>
  </div>
</nav>
    <div className='transaction-detail-section'>
    <table class="table table-striped transaction-table">
  <thead>
    <tr>
      <th scope="col">TRANSACTION ID</th>
      <th scope="col">TRANSACTION DATE</th>
      <th scope="col">Order ID & AWB</th>
      <th scope="col">WEIGHT</th>
      <th scope="col">ZONE</th>
      <th scope="col">SPEND AMOUNT</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>  <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    <tr>
      <th scope="row">1123312</th>
      <td>20/09/2024</td>
      <td>12345678</td>
      <td>500g</td>
      <td>North</td>
      <td>90.00</td>
    </tr>
    
  </tbody>
</table> 
</div>
</div>
    </div>
  )
}

export default Transaction
